module.exports = __webpack_public_path__ + "dl.5594b8e0.svg";